export default __webpack_public_path__ + "static/media/meeting-crm.b732beaa.svg";